import { render } from "./ImageEditorDashboard.vue?vue&type=template&id=2c83c7c4&scoped=true"
import script from "./ImageEditorDashboard.vue?vue&type=script&lang=js"
export * from "./ImageEditorDashboard.vue?vue&type=script&lang=js"

import "./ImageEditorDashboard.vue?vue&type=style&index=0&id=2c83c7c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c83c7c4"

export default script